/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const DeviceTrust32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 7.692v16.616c0 2.675.278 3.645.801 4.622A5.452 5.452 0 003.07 31.2c.978.522 1.948.801 4.623.801h16.616c2.675 0 3.645-.279 4.622-.801A5.452 5.452 0 0031.2 28.93c.522-.977.801-1.947.801-4.622V7.692c0-2.675-.279-3.645-.801-4.623A5.452 5.452 0 0028.93.801C27.953.278 26.983 0 24.308 0H7.692C5.017 0 4.047.278 3.069.801A5.452 5.452 0 00.801 3.07C.278 4.047 0 5.017 0 7.692z"
            fill={vars.bdlDarkBlue}
        />
        <path d="M7 10a1 1 0 011-1h16a1 1 0 011 1v11H7V10z" fill="#fff" />
        <path d="M13 15a1 1 0 011-1h4a1 1 0 011 1v3a1 1 0 01-1 1h-4a1 1 0 01-1-1v-3z" fill={vars.bdlDarkBlue} />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18 14h-4v-1a2 2 0 114 0v1zm-2-2a1 1 0 00-1 1v1h2v-1a1 1 0 00-1-1z"
            fill={vars.bdlDarkBlue}
        />
        <path d="M5 22h22v1a1 1 0 01-1 1H6a1 1 0 01-1-1v-1z" fill="#fff" />
        <path d="M14 22h4a1 1 0 01-1 1h-2a1 1 0 01-1-1z" fill={vars.bdlDarkBlue} />
    </AccessibleSVG>
);

export default DeviceTrust32;
